import { useMemo } from "react";
import { useGetPatientTaskByTypeQuery } from "src/api/services/tasksApi";
import { TaskType } from "src/api/types";
import ActionItem from "src/pages/PatientDashboard/components/ActionItems/components/ActionItem";
import WhiteCard from "src/shared/components/WhiteCard";

interface Props {
  type: TaskType;
}

const ActionTask = ({ type }: Props) => {
  const { data } = useGetPatientTaskByTypeQuery(type);

  const item = useMemo(() => {
    if (data == null) return null;

    return data;
  }, [data]);

  if (item == null) return null;
  return (
    <WhiteCard gap={2}>
      <ActionItem item={item} />
    </WhiteCard>
  );
};

export default ActionTask;
